import React, { Component } from "react";
import { connect } from "react-redux";

import AreaHeader from "./AreaHeader";
import { AreaStats } from "../stats";
import FieldNames from "../../../aiim/datasets/FieldNames";
import OfficePlan from "../../base/OfficePlan";
import Rdx from "../../../redux/Rdx";
import Topic from "../../../context/Topic";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as component from "../../../components/util/component";

import {
  ListItem,
  ListItemTitle,
  ListItemSubtitle
} from "../../styles/Common/list";

class HotDeskArea extends Component {

  _mounted = false;

  constructor(props) {
    super(props);
    this.state = component.newState({});
  }

  componentDidMount() {
    this._mounted = true;

    component.own(this, [
      Topic.subscribe(Topic.PlanModified, params => {
        const actions = [OfficePlan.Action_AssignmentsUpdated];
        if (actions && actions.indexOf(params.action) !== -1) {
          component.refresh(this);
        }
      })
    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
    this._mounted = false;
  }

  getAreaId() {
    const areaItem = this.getAreaItem();
    return aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_ID);
  }

  getAreaItem() {
    return this.state.areaItem || this.props.areaItem;
  }

  getAreaType() {
    return OfficePlan.SpaceAssignmentTypes.hotdesk;
  }

  hasActive() {
    return !!(this.props.rdxActiveAreaId);
  }

  isActive() {
    return (this.hasActive() && this.props.rdxActiveAreaId === this.getAreaId());
  }

  toggleDetails = (event, rdxActiveAreaKey) => {
    Rdx.setValue(this, rdxActiveAreaKey, this.getAreaId());
  };

  render() {
    const rdxActiveAreaKey = Rdx.Keys.ACTIVE_HOTDESK_AREA_ID;
    const { rdxActiveAreaId } = this.props;
    const areaItem = this.getAreaItem();
    const areaType = this.getAreaType();

    return (
      <ListItem onClick={event => this.toggleDetails(event, rdxActiveAreaKey)}>
        <ListItemTitle>
          <AreaHeader areaItem={areaItem} areaType={areaType} rdxActiveAreaKey={rdxActiveAreaKey} rdxActiveAreaId={rdxActiveAreaId} />
        </ListItemTitle>
        <ListItemSubtitle>
          <AreaStats areaItem={areaItem} areaType={areaType} />
        </ListItemSubtitle>
      </ListItem>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const rdxActiveAreaKey = Rdx.Keys.ACTIVE_HOTDESK_AREA_ID;
  return {
    rdxActiveAreaId: Rdx.getValue(state, rdxActiveAreaKey)
  }
}

export default connect(mapStateToProps)(HotDeskArea);
